import React, { useEffect, useRef, useState } from "react";
import "./CriarPerfilTrilhoModal.css";

const normalizePerfilNumero = (value, max = 3) => String(value ?? "").replace(/\D/g, "").slice(0, max);

export default function CriarPerfilTrilhoModal({ open, onClose, onSalvar }) {
  const [numero, setNumero] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const numeroRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setNumero("");
    setBusy(false);
    setErr("");

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => numeroRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const normalized = normalizePerfilNumero(numero);
      if (!normalized) throw new Error("Informe o numero do perfil.");
      await onSalvar?.(normalized);
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ptcmd-overlay" onClick={onClose}>
      <div className="ptcmd-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Cadastrar perfil de trilho">
        <div className="ptcmd-head">
          <h3 className="ptcmd-title">Cadastrar Perfil de Trilho</h3>
          <button className="ptcmd-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="ptcmd-body">
          <label className="ptcmd-field">
            <span>Perfil de trilho</span>
            <div className="ptcmd-prefixed">
              <span className="ptcmd-prefix">TR</span>
              <input
                ref={numeroRef}
                type="text"
                inputMode="numeric"
                value={numero}
                onChange={(event) => setNumero(normalizePerfilNumero(event.target.value))}
                placeholder="Ex: 60"
                autoComplete="off"
              />
            </div>
          </label>
          {err ? <div className="ptcmd-error">{err}</div> : null}
        </div>

        <div className="ptcmd-foot">
          <button className="ptcmd-btn ptcmd-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="ptcmd-btn ptcmd-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}

